import React from "react";
import classNames from "classnames";
import { ReportSectionProps } from "./types";
import classes from "./report-section.module.scss";

export const ReportSection = ({
    id,
    title,
    updatedAt,
    badge,
    dot,
    children
}: ReportSectionProps) => {
    return (
        <div id={id} className={classes["report-section"]}>
            <div className={classes["report-section__header"]}>
                <h3
                    className={classNames(classes["report-section__title"], {
                        [classes["report-section__title--extend"]]: updatedAt
                    })}
                >
                    {title}
                </h3>
                {badge && <div className={classes["report-section__badge"]}>{badge}</div>}
                {dot !== undefined && (
                    <div
                        className={classNames(
                            classes["report-section__dot"],
                            !dot && classes["report-section__dot--warn"]
                        )}
                    />
                )}
            </div>
            {updatedAt && <div className={classes["report-section__updated"]}>{updatedAt}</div>}
            <div className={classes["report-section__content"]}>{children}</div>
        </div>
    );
};